module.exports = __webpack_public_path__ + "static/media/MSME.ee5dec11.png";